﻿//public delegate void EpochSelection(int epochIndex);

import {UIButton} from "../Tools/Base/UIButton";
import {UIImage} from "../Tools/Base/UIImage";
import {UIText} from "../Tools/Base/UIText";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";

export class EpochButton extends UIButton {
    get selected() {
        return this.chosenImg.Active;
    }

    set selected(val) {
        return this.chosenImg.SetActive(!!val);
    }

    Awake() {
        super.Awake();
        this.btn = this.addChild(new UINineSlice("button-biomselect"));
        this.chosenImg = this.addChild(new UINineSlice("button-biomselect"));
        this.img = this.addChild(new UIImage());
        this.nameField = this.addChild(new UIText("", { fontSize: 60 }));
        this.chosenImg.tint = 0xff9900;
    }

    Init(epoch) {
        this.nameField.text = Core.Localizator.Get(epoch.epochName);
        this.chosenImg.SetActive(false);
        this.img.setImage(`creatures/${epoch.creatures[0]}`);
    }

    fitLayout(rect) {
        this.position.set(rect.x, rect.y);

        this.btn.scale.set(0.1);
        this.btn.width = rect.width / this.btn.scale.x;
        this.btn.height = rect.height / this.btn.scale.y;

        this.chosenImg.scale.set(this.btn.scale.x);
        this.chosenImg.width = this.btn.width;
        this.chosenImg.height = this.btn.height;

        let tmpRect = rect.clone();
        tmpRect.height = rect.height * 0.8;
        tmpRect.width = rect.width * 0.9;
        tmpRect.y = 0;
        tmpRect.x = (rect.width - tmpRect.width) * 0.5;
        this.img.position.set(tmpRect.x + tmpRect.width * 0.5, tmpRect.y + tmpRect.height * 0.5);
        this.img.scale.set(Math.min((tmpRect.width * 0.8) / this.img.texture.width, (tmpRect.height * 0.8) / this.img.texture.height));

        tmpRect = rect.clone();
        tmpRect.height = rect.height * 0.2;
        tmpRect.width = rect.width * 0.9;
        tmpRect.y = (rect.height - tmpRect.height) * 0.9;
        tmpRect.x = (rect.width - tmpRect.width) * 0.5;
        this.nameField.fitLayout(tmpRect);
    }
}

export class UINextEpochChoose extends UICommonPopup {
    Awake() {
        super.Awake();

        this.buttons = []; // EpochButton[] buttons;

        this.okBtn = this.content.addChild(new UINineSliceButton("btn-gray", { label: Core.Localizator.Get("ok") }));

        this.title = this.content.addChild(new UIText(Core.Localizator.Get("next_epoch_title")));

        this.selection = undefined;

        this.onClickOk = this.onClickOk.bind(this);
        this.okBtn.on("pointertap", this.onClickOk);
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.2;
        let w = Math.min(viewport.width * 0.95, (viewport.height * 0.95) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.15;
        rect.width = popupRect.width * 0.7;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.07;
        this.title.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width;
        rect.height = popupRect.height * 0.4;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.5;

        for (let i = 0; i < this.buttons.length; i++) {
            let tmpRect = rect.clone();
            tmpRect.width = (rect.width * 0.9) / Math.max(this.buttons.length || 1, 2);
            tmpRect.height = rect.height;
            tmpRect.x = rect.width * 0.5 + tmpRect.width * 0.52 * (-this.buttons.length + 1 + 2 * i) - tmpRect.width * 0.5;
            tmpRect.y = rect.y;
            this.buttons[i].fitLayout(tmpRect);
        }

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.43;
        rect.height = popupRect.height * 0.15;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.95;
        this.okBtn.fitLayout(rect);
    }

    _handleSelection(index) {
        this.selection = index;
        for (let button of this.buttons) {
            button.selected = button === this.buttons[index];
        }

        this.okBtn.interactive = true;
        this.okBtn.setImage("btn-green");
    }

    _createButtons(epochs) {
        this._clearButtons();

        epochs = epochs.filter((e) => !Core.Player.IsEpochLocked(e.id));
        for (let i = 0; i < epochs.length; i++) {
            let epoch = epochs[i];
            let btn = this.content.addChild(new EpochButton());
            btn.Init(epoch);
            btn.on("pointertap", this._handleSelection.bind(this, i));
            this.buttons.push(btn);
        }
    }

    _clearButtons() {
        for (let btn of this.buttons) {
            btn.off("click");
            this.content.removeChild(btn);
        }
        this.buttons.splice(0);
    }

    onClickOk() {
        if (this.selection === undefined) return;
        this.emit("EpochSelected", this.selection);
        this._clearButtons();
        this.Hide();
    }

    Show(callback, epochs) {
        this.selection = undefined;

        this.on("EpochSelected", callback);
        this._createButtons(epochs);

        this.okBtn.interactive = false;
        this.okBtn.setImage("btn-gray");

        this.fitLayout();
        super.Show();
    }

    Hide() {
        super.Hide();
        this.off("EpochSelected");
    }
}
